import http from '@/services/api/http';

export default {
  getFaqs() {
    return http.get('api/about/faqs');
  },
  getSitemap() {
    return http.get('api/About/sitemap');
  },
};



// WEBPACK FOOTER //
// ./src/services/api/about.js